import React from "react";
import styles from "./Team.module.css";
import { TEAM_MEMBERS } from "../../../data/team";
import { Animate, Stagger } from "../../animations";

const Team = () => {
  return (
    <section className={styles.teamContainer}>
      <div className={styles.teamInner}>
        <Animate variant="fadeUp">
          <h4 className={styles.heading}>Those Behind The Scenes</h4>
          <h1 className={styles.subHeading} id="heading-large">
            A Committed Team That Achieves
          </h1>
        </Animate>
        <Stagger className={styles.teamCards} variant="scaleIn" stagger={90}>
          {TEAM_MEMBERS.map((member) => (
            <div key={member.name} className={`${styles.teamCard} anim-hover-lift`}>
              <img src={member.image} alt={member.name} />
              <div className={styles.overlay}>
                <p>
                  {member.name} — {member.role}
                </p>
                <div className={styles.socialIcons}>
                  <i className="fab fa-facebook"></i>
                  <i className="fab fa-instagram"></i>
                  <i className="fab fa-linkedin"></i>
                </div>
              </div>
            </div>
          ))}
        </Stagger>
      </div>
    </section>
  );
};

export default Team;
